export default __webpack_public_path__ + "static/media/Evaluation_icon.80751713.gif";